import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useMemo } from 'react';
const StateNodeSelect = ({ stateNodeConfig, label, value, getOptionLabel, onChange }) => {
    const pathMap = useMemo(() => getStateNodePathMap(stateNodeConfig), [
        stateNodeConfig
    ]);
    return (React.createElement(Autocomplete, { fullWidth: true, disableClearable: true, className: 'state-node-select', getOptionLabel: path => (getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(path, pathMap)) || path, getOptionSelected: (option, value) => option === value, value: value || '', options: Array.from(pathMap.keys()), onChange: (event, value) => {
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }, renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', InputProps: Object.assign(Object.assign({}, params.InputProps), { disableUnderline: true }), 
            // variant='outlined'
            label: label }))) }));
};
export default StateNodeSelect;
const getStateNodePathMap = (stateNodeConfig, parentPath = '', pathMap) => {
    if (!pathMap)
        pathMap = new Map();
    const path = `${parentPath}/${stateNodeConfig.name}`;
    if (parentPath) {
        // skip adding root state node
        pathMap.set(path, stateNodeConfig);
    }
    if (stateNodeConfig.states) {
        for (const childStateNodeConfig of stateNodeConfig.states) {
            getStateNodePathMap(childStateNodeConfig, path, pathMap);
        }
    }
    return pathMap;
};
//# sourceMappingURL=StateNodeSelect.js.map